import { BASE_STORE_URL } from '@/request/config';
import request from '@/request/tsRequest';
import type { IRecommendListDTO } from '@/components/Search/components/Recommends/typings';

/** 获取搜索推荐词条 */
export function getRecommends() {
  return request<IRecommendListDTO[]>({
    url: BASE_STORE_URL + '/search/recommendText',
  });
}
